import { memo } from "react";
import { TextField } from "ui/components/TextField/TextField";
import { ChipToggle, SectionCard } from "../primitives";

interface Props {
  youtubeUrl: string;
  videoCallViewing: boolean;
  onYoutubeChange: (next: string) => void;
  onVideoCallViewingChange: (checked: boolean) => void;
}

const VideoSection: React.FC<Props> = ({
  youtubeUrl,
  videoCallViewing,
  onYoutubeChange,
  onVideoCallViewingChange,
}) => (
  <SectionCard title="Video (opcionalno)">
    <div>
      <TextField
        type="text"
        name="youtubeUrl"
        label="Adresa YouTube videa"
        placeholder="https://www.youtube.com/watch?v=..."
        value={youtubeUrl}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onYoutubeChange(e.target.value)}
      />
    </div>

    <div className="mt-4">
      <ChipToggle
        label="Razgledavanje video pozivom"
        selected={videoCallViewing}
        onToggle={() => onVideoCallViewingChange(!videoCallViewing)}
      />
    </div>
  </SectionCard>
);

export default memo(VideoSection);
